import { graphql } from "@server/gql";

export const getUserQuery = graphql(/* GraphQL */ `
  query getUser($email: String!) {
    user(email: $email) {
      ...user
    }
  }
`);
